import { Stack, Box, styled, TextField, Divider } from "@mui/material";
import { useState } from "react";
import { DatePicker } from "../../atoms/DatePicker";

export const DateInput = styled("input")({
  border: "none",
  backgroundColor: "transparent",
  width: "100%",
  padding: "0.9375rem",
  fontSize: "1rem",
  fontWeight: 400,
  color: "white",
  "&:focus, &:hover": {
    border: "none",
    outline: "none",
  },
});
